import { useMemo } from 'react';

import { ModuleEntityType } from '~/common/types';
import { DateRangeProvider } from '~/components/DateRangeProvider';
import { ModuleContextProvider, ModuleContextProviderValue } from '~/components/ModuleContextProvider';
import { ModulePage } from '~/components/ModulePage/ModulePage';
import { useModulePageConfig } from '~/components/ModulePageConfigProvider';
import { ModuleSlot } from '~/components/ModuleSlot/ModuleSlot';
import { ResponsibleUsersProvider } from '~/components/ResponsibleUsersProvider';
import { ModuleSlotId } from '~/modules';
import { useOrderDetail, useTabId } from '~/modules/Module.hooks';
import { RouteId } from '~/routes';

import { OrderDetailHeader } from './PurchaseOrderDetailHeader/PurchaseOrderDetailHeader';

export const PurchaseOrderDetail = () => {
  const { orderId } = useOrderDetail();
  const { tabId } = useTabId();

  const { modules, tabs } = useModulePageConfig({ pageId: RouteId.orderDetail(), tabId });

  const contextValue = useMemo<ModuleContextProviderValue>(
    () => ({ entity: ModuleEntityType.ORDER, entityId: orderId }),
    [orderId],
  );

  return (
    <DateRangeProvider>
      <ResponsibleUsersProvider>
        <ModulePage
          header={<OrderDetailHeader id={orderId} tabs={tabs} />}
          modules={
            <ModuleContextProvider value={contextValue}>
              <ModuleSlot id={ModuleSlotId.MAIN} modules={modules} />
            </ModuleContextProvider>
          }
        />
      </ResponsibleUsersProvider>
    </DateRangeProvider>
  );
};
